module.exports = __webpack_public_path__ + "img/test1.3944c2d4.png";